import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';
import { useBreakpoints } from '@design-system/breakpointsStore';

const digitalProSeriesVideos = [
  'https://www.loom.com/embed/a0fc454f679d4c269cb734ec3999585a?sid=f58544ed-f029-428e-947d-20f0a74781fa&hideEmbedTopBar=true',
  'https://www.loom.com/embed/22429f50b198494b881a6abf42173c55?sid=5c68be01-da8a-4688-9701-272f7b7b069c&hideEmbedTopBar=true',
  'https://www.loom.com/embed/331973cd17554ecb8a492a121e79e5bb?sid=0ff67e58-cd5c-49e2-b816-08ec3dee87aa&hideEmbedTopBar=true',
  'https://www.loom.com/embed/aeec8844609c428fa9f76102296c0fc1?sid=03008831-cfc9-492e-a0b6-bf5f666b14c0&hideEmbedTopBar=true',
];

export const DigitalProSeries = () => {
  const isMobile = useBreakpoints((s) => s.mobile);
  const width = isMobile ? 350 : 470;
  return (
    <div className="flex flex-col gap-8">
      <Typography className="text-center">
        Based on our experience, we believe the following resources will be
        valuable as you prepare for your launch.
      </Typography>
      <div className="flex flex-col items-center xl:flex-row gap-8 justify-between rounded-[20px] bg-white p-8">
        <div className="flex flex-col gap-6 md:w-[410px]">
          <Typography variant="display" size="large">
            Everything you need to get started!
          </Typography>
          <Typography variant="title">
            To help you get started, we've created a step-by-step guide & video
            tutorials that will show you how to set up and begin selling like
            the top-performing creators! 🙌
          </Typography>
          <a
            className="w-max mt-2"
            href="https://docs.google.com/document/d/1ufQNOy-6-v5VfnPDrDEVJqIPCV_ILOtPY-wGM2ZakbE/preview"
            target="_blank"
            rel="noreferrer"
          >
            <div
              className={clsx(
                'flex gap-2 px-4 py-2 rounded-[10px]',
                sprinkles({ bg: 'P-80', color: 'W-100' }),
              )}
            >
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              <Typography>Success Guide</Typography>
            </div>
          </a>
        </div>
        <div className="flex flex-col gap-4 w-[350] md:min-w-[512px] h-[373px] overflow-y-scroll">
          {digitalProSeriesVideos.map((url) => (
            <iframe
              key={url}
              src={url}
              allowFullScreen
              style={{ borderRadius: '20px' }}
              width={width}
            ></iframe>
          ))}
        </div>
      </div>
    </div>
  );
};
